import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message } from "antd";
import { ArrowRightOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, ExpandOutlined, EyeOutlined } from "@ant-design/icons";
import "../../assets/dist/NewApplication/ApplicantPreview.css";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APP_BLOB_ROOT } from "../../constants/constants";
import _commonService from "../../modules/commonService";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../constants/constants";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { PRIVATE_WEALTH_ADVISOR_ROLE } from "../../constants/DataConstants";
import CommentSection from "./CommentSection";
import "./ApplicationDetailsTab.scss"
const { Text, Title } = Typography;
const { confirm } = Modal;

const ApplicationDetailsTab = ({ activeKey, ApplicationObjId }) => {
  const history = useHistory();
  const [applicantDetails, setApplicantDetails] = useState({});
  const [loading, setLoading] = useState(false);
  //let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
  // const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isCobModalVisible, setIsCobModalVisible] = useState(false);

  // const showCobFullScreenModal = () => setIsCobModalVisible(true);
  // const handleCobClose = () => setIsCobModalVisible(false);

  // const showApplicantFullScreenModal = () => setIsModalVisible(true);
  // const handleClose = () => setIsModalVisible(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState('');
  const [selectedDocName, setSelectedDocName] = useState('');
  const isPrivateWealthAdvisor = localStorage.getItem("userRole") === PRIVATE_WEALTH_ADVISOR_ROLE;

  // const documents = [];

  // if (applicantDetails?.UpDoc_Personal_FinStatement_Path) {
  //   documents.push("Personal Financial Statement");
  // }
  // if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
  //   documents.push("Patriot Act Form (Applicant)");
  // }
  // if (applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2) {
  //   documents.push("Patriot Act Form (Co-Borrower)");
  // }
  // if (applicantDetails?.UpDoc_Credit_Breau_Report_Path) {
  //   documents.push("Credit Bureau Report");
  // }
  // if (applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR) {
  //   documents.push("Credit Bureau Report (Co-Borrower)");
  // }
  // if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
  //   documents.push("First Two Pages Of Personal Tax Return");
  // }

  useEffect(() => {
    if (activeKey && activeKey == "2") {
      getApplicantDetailsByID(ApplicationObjId);
    }
  }, [activeKey]);

  const getApplicantDetailsByID = async (ApplicationObjId) => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantInformationByApplicationId(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // const handleApplicationIdentDownload = () => {
  //   if (applicantDetails?.Ident_Photo_Of_Id_Path) {
  //     setLoading(true);
  //     const fileUrl = APP_BLOB_ROOT + applicantDetails.Ident_Photo_Of_Id_Path;
  //     const fileName = applicantDetails.Ident_Photo_Of_Id_Path.split("/").pop();

  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.setAttribute("download", fileName); // optional custom file name
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     setLoading(false);
  //   }
  // };

  // const handleCobIdentDownload = () => {
  //   if (applicantDetails?.CoB_Ident_Photo_Of_Id_Path) {
  //     setLoading(true);
  //     const fileUrl = APP_BLOB_ROOT + applicantDetails.CoB_Ident_Photo_Of_Id_Path;
  //     const fileName = applicantDetails.CoB_Ident_Photo_Of_Id_Path.split("/").pop();

  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.setAttribute("download", fileName); // optional custom file name
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     setLoading(false);
  //   }
  // };

  const handleCertificateOfTrustDownload = () => {
    if (applicantDetails?.Pot_Certificate_Of_Trust_Path) {
      setLoading(true);
      // const fileUrl = APP_BLOB_ROOT + applicantDetails.Pot_Certificate_Of_Trust_Path;
      const fileUrl = applicantDetails.Pot_Certificate_Of_Trust_Path;
      const fileName = applicantDetails.Pot_Certificate_Of_Trust_Path.split("/").pop();

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName); // optional custom file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    }
  };

  const deleteCertOfTrustDoc = () => {
    confirm({
      title: "Are you sure, want to delete this Certificate Of Trust?",
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteObj();
      }
    });
  };

  const deleteObj = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), "certificationoftrust");
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const onDocumentEyeClick = (item) => {
    setSelectedDocName(item.name);
    setSelectedDocUrl(item.url);
    setIsModalVisible(true);
  };

  const onDocumentDownloadClick = (item) => {
    if (item === "Personal Financial Statement") {
      if (applicantDetails?.UpDoc_Personal_FinStatement_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileUrl = applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileName = applicantDetails.UpDoc_Personal_FinStatement_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "Patriot Act Form (Applicant)") {
      if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileUrl = applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileName = applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Patriot Act Form (Co-Borrower)") {
      setLoading(true);
      //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
      const fileUrl = applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
      const fileName = applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2.split("/").pop();

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    } else if (item === "Credit Bureau Report") {
      if (applicantDetails?.UpDoc_Credit_Breau_Report_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileUrl = applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileName = applicantDetails.UpDoc_Credit_Breau_Report_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Credit Bureau Report (Compliance Admin)") {
      setLoading(true);
      //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
      const fileUrl = applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
      const fileName = applicantDetails.UpDoc3_Credit_Bureau_Report_CBR.split("/").pop();

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    } else if (item === "First Two Pages Of Personal Tax Return") {
      if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path;
        const fileUrl = applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path;
        const fileName = applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else {
      console.error("Unknown document type:", item);
    }
  };

  const deleteDocument = (item) => {
    confirm({
      title: `Are you sure, want to delete this ${item.name}?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        deleteDocumentObj(item.name);
      }
    });
  };

  const deleteDocumentObj = async (item) => {
    console.log("item", item);
    setLoading(true);
    let documentType = "";
    if (item === "Personal Financial Statement") {
      documentType = "personalfinancialstatement";
    } else if (item === "Patriot Act Form (Applicant)") {
      documentType = "updoc1_patriot_act_form_applicant";
    } else if (item === "Patriot Act Form (Co-Borrower)") {
      documentType = "updoc2_patriot_act_form_coborrower_path_2";
    } else if (item === "Credit Bureau Report") {
      documentType = "credit_bureau_report";
    } else if (item === "Credit Bureau Report (Compliance Admin)") {
      documentType = "updoc3_credit_bureau_report_cbr";
    } else if (item === "First Two Pages Of Personal Tax Return") {
      documentType = "updoc3_firsttwo_pages_tax_return_path";
    } else {
      console.error("Unknown document type:", item);
    }

    try {
      const res = await _NewapplicationService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), documentType);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
        getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
      } else {
        setLoading(false);
        message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  // const onEditApplicantIdentClick = () => {
  //   history.push({
  //     pathname: routes.applicantsIdentification.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }

  // const onCoBorrowerEditClick = () => {
  //   history.push({
  //     pathname: routes.coBorrowersDetails.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }

  // const onIdentCoBorrowerEditClick = () => {
  //   history.push({
  //     pathname: routes.identificationOfcoBorrower.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }

  // const onProofOfTrustEditClick = () => {
  //   history.push({
  //     pathname: routes.ProofOfTrust.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }

  // const onDocumentsEditClick = () => {
  //   history.push({
  //     pathname: routes.uploaddocuments.path,
  //     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), isFromDashboard: true, activeKey },
  //   });
  // }

  const documentMap = {
    "Personal Financial Statement": applicantDetails?.UpDoc_Personal_FinStatement_Path,
    "Credit Bureau Report": applicantDetails?.UpDoc_Credit_Breau_Report_Path,
    "Credit Bureau Report (Compliance Admin)": applicantDetails?.UpDoc3_Credit_Bureau_Report_CBR,
  };

  // const documents = Object.entries(documentMap)
  //   .filter(([_, path]) => !!path)
  //   .map(([name, path]) => ({ name, url: path }));

  const getFileNameFromUrl = (url = "") =>
    url.split("?")[0].split("/").pop();

  const documents = Object.entries(documentMap)
    .filter(([_, path]) => !!path)
    .map(([name, path]) => ({
      name,
      isMulti: false,
      url: path,
    }));

  // Multiple-file upload fields (Multipleupload.md Section 5): Patriot Act Form (Applicant/Co-
  // Borrower) and Tax Return can now hold several files each, same as Capital Account/Liquidity
  // Statements below, so they're listed the same way instead of via documentMap above.
  if (applicantDetails?.UpDoc1_Patriot_Act_Form_Applicant_Path) {
    documents.push({
      name: "Patriot Act Form (Applicant)",
      isMulti: true,
      files: applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2) {
    documents.push({
      name: "Patriot Act Form (Co-Borrower)",
      isMulti: true,
      files: applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc3_FirstTwo_Pages_Tax_Return_Path) {
    documents.push({
      name: "First Two Pages Of Personal Tax Return",
      isMulti: true,
      files: applicantDetails.UpDoc3_FirstTwo_Pages_Tax_Return_Path
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_Capital_Account_Statements) {
    documents.push({
      name: "Capital Account Statements",
      isMulti: true,
      files: applicantDetails.UpDoc_Capital_Account_Statements
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_Liquidity_Statements) {
    documents.push({
      name: "Liquidity Statements",
      isMulti: true,
      files: applicantDetails.UpDoc_Liquidity_Statements
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  if (applicantDetails?.UpDoc_AML_KYC_Docs) {
    documents.push({
      name: "AML/KYC Documents (Compliance Admin)",
      isMulti: true,
      files: applicantDetails.UpDoc_AML_KYC_Docs
        .split(",")
        .filter(Boolean)
        .map((url) => ({
          name: getFileNameFromUrl(url),
          url,
        })),
    });
  }

  // const handleView = (item) => {
  //   console.log("item", item)
  //   setSelectedDoc(APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path);
  //   setIsModalVisible(true);
  // };

  console.log("A++", selectedDocUrl)

  const downloadFile = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Spin spinning={loading}>
      {applicantDetails && ["1", "3", "4"].includes(applicantDetails.App_Det_Application_Type_Id) && 
        <Card
          className="card-section application-detail-card mt10 custom"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Identification Details
              </Text>
              {/* <EditOutlined onClick={onEditApplicantIdentClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
        >

          <div className="application-detail-content">
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <Text type="secondary">ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Type}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.Ident_Identification_Number) : null}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Date_Of_Issue)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.Ident_Expiration_Date)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State_Of_Issue}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Nationality:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Nationality}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">City:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_City}</Text>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Zip Code:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_ZipCode}</Text>
              </Col>
              <Col xs={24} md={16}>
                <Text type="secondary">Street Address:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_Physical_Address}</Text>
              </Col>
            </Row>
            <CommentSection CommentSectionName="aapplicationidentification" applicationstatusid={applicantDetails.Application_Status_Id} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
      }

      {applicantDetails && applicantDetails.App_Det_Application_Type_Id == "4" &&
        <Card
          className="card-section application-detail-card mt10 custom"
          className="card-section application-detail-card mt10 custom"
          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Co-Borrower
              </Text>
              {/* <EditOutlined onClick={onCoBorrowerEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
        >
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8}>
                <Text type="secondary">First Name:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_FirstName}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Last Name:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_LastName}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Date Of Birth:</Text><br />
                <Text className="b-bottm">{applicantDetails && _commonService.convertToMMDDYYYY(applicantDetails.CoB_DateOfBirth)}</Text>
              </Col>

              <Col xs={24} sm={8}>
                <Text type="secondary">Contact Number:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_ContactNumber ? _commonService.formatUSPhoneNumber(applicantDetails.CoB_ContactNumber) : "N/A"}</Text>
              </Col>
              <Col xs={24} sm={8}>
                <Text type="secondary">Relationship With Client:</Text><br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Relationship_With_Applicant}</Text>
              </Col>
            </Row>
            <CommentSection CommentSectionName="coborrowerdetails" applicationstatusid={applicantDetails.Application_Status_Id} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
      }

      {applicantDetails && applicantDetails.App_Det_Application_Type_Id == "4" &&
        <Card
          className="card-section application-detail-card mt10 custom"
          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
                Co-Borrower's Identification & Address
              </Text>
              {/* <EditOutlined onClick={onIdentCoBorrowerEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
        >

          <div>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={8}>
                <Text strong>ID Type:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Type}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>ID Number:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Identification_Number ? _commonService.maskLast4Digits(applicantDetails.CoB_Ident_Identification_Number) : null}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>Date Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_DateOfIssue)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>Expiration Date:</Text> <br />
                <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.CoB_Ident_ExpirationDate)}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text strong>State Of Issue:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_State_Of_Issue}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Nationality:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Nationality}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_State : applicantDetails.CoB_Ident_State}</Text>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">City:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_City : applicantDetails.CoB_Ident_City}</Text>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Zip Code:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_ZipCode : applicantDetails.CoB_Ident_ZipCode}</Text>
              </Col>
              <Col xs={24} md={16}>
                <Text type="secondary">Street Address:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CoB_Ident_Address_Type == true ? applicantDetails.Ident_Physical_Address : applicantDetails.CoB_Ident_Physical_Address}</Text>
              </Col>
            </Row>
            <CommentSection CommentSectionName="coborroweridentification" applicationstatusid={applicantDetails.Application_Status_Id} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>
      }

      {applicantDetails && (applicantDetails.App_Det_Application_Type_Id == "2" || applicantDetails.App_Det_Application_Type_Id == "3") &&
        <Card
          className="card-section application-detail-card mt10 custom"

          bodyStyle={{ padding: 24 }}
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🛡️</span>
                Proof Of Trust
              </Text>
              {/* <EditOutlined onClick={onProofOfTrustEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
        >
          {/* Info Grid */}
          <div>
            <Row gutter={[24, 16]}>
              <Col xs={24} md={8}>
                <Text type="secondary">Type Of Trust</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Trust_Type_Name}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Legal Name Of The Trust</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Legal_Name_Of_Trust}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Name Of The Grantor</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Name_Of_Grantor}</span>
              </Col>

              <Col xs={24} md={8}>
                <Text type="secondary">Date Of Trust Creation</Text>
                <span className="b-bottm">{applicantDetails && _commonService.convertToMMDDYYYY(applicantDetails.Pot_Date_Of_Trust_Creation)}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">Trust’s Tax ID (If Any)</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_Trust_Tax_Id}</span>
              </Col>
              <Col xs={24} md={8}>
                <Text type="secondary">State Of Trust Formation</Text>
                <span className="b-bottm">{applicantDetails && applicantDetails.Pot_State_Of_Trust_Formation}</span>
              </Col>
            </Row>
          </div>


          {/* File Row */}
          {applicantDetails?.Pot_Certificate_Of_Trust_Path &&
            <div
              style={{
                // background: "#f5f5f5",
                padding: "12px 0px",
                borderRadius: "0 0 16px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Space>
                <ArrowRightOutlined />
                <Text strong>Certificate Of Trust</Text>
              </Space>

              <Space>
                <Button icon={<EyeOutlined />} type="text" onClick={() => onDocumentEyeClick({ name: "Certificate Of Trust", url: applicantDetails.Pot_Certificate_Of_Trust_Path })} />
                <Button icon={<DownloadOutlined />} type="text" target="_blank" onClick={handleCertificateOfTrustDownload} />
                {!isPrivateWealthAdvisor && (
                  <Button className="displayNone" icon={<DeleteOutlined />} type="text" danger onClick={() => deleteCertOfTrustDoc()} />
                )}
              </Space>
            </div>
          }
          <CommentSection CommentSectionName="proofoftrust" applicationstatusid={applicantDetails.Application_Status_Id} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
        </Card>
      }

      {documents && documents.length > 0 &&



        <Card
          style={{ borderRadius: 16 }}
          bodyStyle={{ padding: 0 }}
          className="card-section application-detail-card mt10 custom"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🧾</span>
                Documents
              </Text>
              {/* <EditOutlined onClick={onDocumentsEditClick} style={{ color: "#595959", cursor: "pointer" }} /> */}
            </Row>
          }
        >
          <div className="card-section-app">
            <List
              dataSource={documents}
              renderItem={(item, index) => (
                <List.Item
                  // style={{
                  //   padding: "12px 24px",
                  //   backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                  //   borderBottom: index === documents.length - 1 ? "none" : "1px solid #f0f0f0",
                  // }}

                  actions={
                    item.isMulti
                      ? []
                      : [
                        <Button
                          icon={<EyeOutlined />}
                          type="text"
                          key="view"
                          onClick={() =>
                            onDocumentEyeClick(item)
                          }
                        />,
                        <Button
                          icon={<DownloadOutlined />}
                          type="text"
                          key="download"
                          onClick={() =>
                            onDocumentDownloadClick(item.name)
                          }
                        />
                        // !isPrivateWealthAdvisor && (
                        //   <Button
                        //     className="displayNone"
                        //     icon={<DeleteOutlined />}
                        //     type="text"
                        //     danger
                        //     key="delete"
                        //     onClick={() =>
                        //       deleteDocument(item)
                        //     }
                        //   />
                        // ),
                      ].filter(Boolean)
                  }
                >
                  {/* <Space size="middle">
                     <Text strong style={{ width: 24 }}>{`0${index + 1}.`}</Text>
                     <Text>{item.name}</Text>

                  </Space> */}

                  <div className="applicationDetailsRowAlign">
                    <Text strong style={{ width: 40 }}>{`0${index + 1}.`}</Text>

                    {item.isMulti ? (
                      <div style={{ flex: 1 }}>
                        <Text strong>{item.name}</Text>

                        <div className="applicationDetailsRowAlign-1">
                          {item.files?.map((file, idx) => (
                            <div
                              key={idx}
                              className="dividerColor applicationDetailsRowAlignDiv"
                            >
                              <Text
                                underline
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  onDocumentEyeClick({
                                    name: file.name,
                                    url: file.url,
                                  })
                                }
                              >
                                {file.name}
                              </Text>

                              <Space size={8} className="mr6">

                                <Button
                                  icon={<EyeOutlined />}
                                  type="text"
                                  key="view"
                                  onClick={() => onDocumentEyeClick({
                                    name: file.name,
                                    url: file.url,
                                  })}
                                />

                                <Divider type="vertical" />

                                <Button
                                  icon={<DownloadOutlined />}
                                  type="text"
                                  key="download"
                                  onClick={() => downloadFile(file.url, file.name)}
                                />
                              </Space>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <Text>{item.name}</Text>
                    )}
                  </div>
                </List.Item>
              )}
            />
            {/* <Divider /> */}
            <Row style={{marginTop: "25px"}}>
              <Col span={4}>
                <Text type="secondary">CBR Score:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore}</Text>
              </Col>

              <Col span={4} style={{ marginLeft: 30 }}>
                <Text type="secondary">Compliance Admin CBR Score:</Text> <br />
                <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore_ComplienceAdmin}</Text>
              </Col>
            </Row>
            <CommentSection CommentSectionName="personalfinancialstatement" applicationstatusid={applicantDetails.Application_Status_Id} applicantDetails={applicantDetails} ApplicationObjId={ApplicationObjId} />
          </div>
        </Card>

      }
      <Modal
        open={isModalVisible}
        title={selectedDocName}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="80vw" // Wider
        bodyStyle={{ height: '80vh', padding: 0 }} // Taller
        destroyOnClose
      >
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title={selectedDocName}
        />
      </Modal>



    </Spin>
  )
}
export default ApplicationDetailsTab;